/**
 * Do not edit directly
 * Generated on Thu, 03 Aug 2023 21:00:07 GMT
 */
export const ColorNeutral0 = "#ffffff";
export const ColorNeutral5 = "#fafafc";
export const ColorNeutral10 = "#eff0f5";
export const ColorNeutral20 = "#e9eaf0";
export const ColorNeutral30 = "#e4e6ed";
export const ColorNeutral40 = "#d4dae0";
export const ColorNeutral50 = "#8b959c";
export const ColorNeutral60 = "#6a7680";
export const ColorNeutral70 = "#4b5963";
export const ColorNeutral80 = "#2d3741";
export const ColorNeutral90 = "#1f252c";
export const ColorNeutral100 = "#111111";
export const ColorBlue10 = "#ecf3ff";
export const ColorBlue20 = "#cfe0ff";
export const ColorBlue30 = "#8fb4f3";
export const ColorBlue40 = "#558ae4";
export const ColorBlue50 = "#2268d9";
export const ColorBlue60 = "#1b4bb2";
export const ColorBlue70 = "#17368e";
export const ColorBlue80 = "#0e2568";
export const ColorBlue90 = "#0a1950";
export const ColorRed10 = "#ffe6e0";
export const ColorRed20 = "#fac5b9";
export const ColorRed30 = "#f5957d";
export const ColorRed40 = "#eb6646";
export const ColorRed50 = "#d93f18";
export const ColorRed60 = "#bd2209";
export const ColorRed70 = "#a20f00";
export const ColorRed80 = "#840c06";
export const ColorRed90 = "#6d0000";
export const ColorYellow10 = "#ffedcc";
export const ColorYellow20 = "#ffdda6";
export const ColorYellow30 = "#fac268";
export const ColorYellow40 = "#f4ac38";
export const ColorYellow50 = "#f0950c";
export const ColorYellow60 = "#d17508";
export const ColorYellow70 = "#c15d00";
export const ColorYellow80 = "#a14807";
export const ColorYellow90 = "#8b380a";
export const ColorGreen10 = "#e9f9d7";
export const ColorGreen20 = "#d4f2b4";
export const ColorGreen30 = "#addc7d";
export const ColorGreen40 = "#71b633";
export const ColorGreen50 = "#408f01";
export const ColorGreen60 = "#266700";
export const ColorGreen70 = "#1e5607";
export const ColorGreen80 = "#16420b";
export const ColorGreen90 = "#12340c";
export const ColorPurple10 = "#f1ebff";
export const ColorPurple20 = "#e2d6ff";
export const ColorPurple30 = "#cab8f3";
export const ColorPurple40 = "#9e84d6";
export const ColorPurple50 = "#7959bb";
export const ColorPurple60 = "#553f90";
export const ColorPurple70 = "#3a2c6e";
export const ColorPurple80 = "#271e55";
export const ColorPurple90 = "#1b1645";
export const ColorAmber50 = "#ffbc00";
export const BIconPurple = "rgba(84, 87, 246, 1)";
export const BIconBlue = "rgba(0, 97, 254, 1)";
export const BIconIndigo = "rgba(54, 60, 158, 1)";
export const BIconMagenta = "rgba(229, 68, 118, 1)";
export const BIconLime = "rgba(165, 209, 103, 1)";
export const BIconGreen = "rgba(68, 174, 65, 1)";
export const BIconTeal = "rgba(0, 144, 158, 1)";
export const BIconYellowDark = "rgba(255, 182, 39, 1)";
export const BIconOrange = "rgba(255, 138, 0, 1)";
